import React, {Component} from 'react';
import _ from 'underscore';
import {
    Search
} from 'semantic-ui-react'

import './style.css';
// const source = [
//     {
//       "title": "Witting, Kub and Jast",
//       "description": "Digitized contextually-based alliance",
//       "image": "https://s3.amazonaws.com/uifaces/faces/twitter/manigm/128.jpg",
//     }
// ];

const prepareClinicSourceList = (clinics) => {
    return _.map(clinics, (clinic, index) => {
        return {
            key: index,
            title: clinic.n,
            description: clinic.a,
            image: `https://app.mhc.asia/v2/api/clinics/${clinic.c}/image`,
        };
    })
}

class ClinicListSearchBar extends Component {

    clinicSourceList = prepareClinicSourceList(this.props.clinics)

    state = {
        isLoading: false,
        results: [],
        value: ''
    }
    componentWillMount() {
        this.setState({ isLoading: false, results: [], value: '' });
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        // console.log('search_bar :: component updated', this.props.mode, prevProps.mode, this.props.mode === prevProps.mode);
        if (this.props.mode !== prevProps.mode && this.props.mode !== 2) {
            this.setState({ isLoading: false, results: [], value: '' });
        }
    }

    resetComponent = () => {
        // console.log('search_bar :: resetComponent');
        this.setState({ isLoading: false, results: [], value: '' });
        this.props.updateMode(1, null);
    }

    handleResultSelect = (e, data) => {
        this.setState({ value: data.result.title });
        this.props.updateMode(2, data.result.key);
    }

    handleSearchChange = (e, data) => {
        this.setState({ isLoading: true, value: data.value });
        setTimeout(() => {
            if (this.state.value.length < 1) return this.resetComponent()
      
            // const re = new RegExp(_.escapeRegExp(this.state.value), 'i')
            const re = new RegExp(this.state.value, 'i')
            const isMatch = result => re.test(result.title + result.description)
      
            this.setState({
              isLoading: false,
              results: _.filter(this.clinicSourceList, isMatch),
            })
        }, 300)
    }

    render() {
        const { isLoading, results, value } = this.state;
        return (
            <Search
                loading={isLoading}
                input={ {fluid : this.props.role === 'sys-admin' ? true : false} }
                onResultSelect={this.handleResultSelect}
                onSearchChange={_.debounce(this.handleSearchChange, 500, { leading: true })}
                results={results}
                value={value}
                fluid
                minCharacters={3}
          />
        )
    }
}

export default ClinicListSearchBar;